import React, { useState, useEffect } from 'react'
import { Col, Container, Row, Button } from "react-bootstrap"
import { FaHistory, FaPlus, FaPencilAlt } from 'react-icons/fa'
import $ from 'jquery';
import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"
import Loader from "./Loader";

import AddUser from './AddUser'
import EditUser from './EditUser'
import ManageUserAudit from './Manage_User_Audit'
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import N from '../lib/Network'
import S from '../lib/Security';
import Utils from '../lib/Utils';
import AppConstants from '../lib/AppConsts';
var CryptoJS = require("crypto-js");
const ManageUser = () => {
    const [showUserPopup, setShowUserPopup] = useState(false);
    const [showUserPopupAudit, setshowUserPopupAudit] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showUserPopupEdit, setShowUserPopupEdit] = useState(false);
    const [data, setData] = useState([]);
    const [oldRecord, setOldRecord] = useState([]);
    const [userRoleStatus, setUserRoleStatus] = useState([]);
    useEffect(() => {
        showLoaderPopup();
        getKeys();
        fetchdatatableData();
        //initialize datatable viewUser
        setTimeout(function () {
            $('#viewUser').DataTable({
                pagingType: 'full_numbers',
                pageLength: 7,
                dom: 'Bfrtip',
                "order": [[1, "desc"]],
                "columns": [
                    { 'searchable': true },
                    { 'searchable': true },
                    { 'searchable': true },
                    { 'searchable': true },
                    {},
                ],
                language: { search: "", searchPlaceholder: "Search By User Name" },
                buttons: [
                    {
                        text: '<i class="fa fa-print" />',
                        className: 'custom-btn',
                        extend: 'print'
                    },
                    {
                        text: '<i class="fa fa-file-excel-o" />',
                        className: 'custom-btn',
                        extend: 'csv'
                    }
                ],
                bDestroy: true,
                "initComplete": function () {
                    $(this).show();
                }
            });
            closeLoader();
        }, 1400);

    }, []);

   
    const fetchdatatableData = () => {
        N.getApi('getUserList')
        .then(res => {
            var response = S.getDecryptedJSON(res);
            setData(JSON.parse(response.responseJson))
        })
    }
    function getKeys() {
        if (S.getPrivateKey() == '' && S.getPublicKey() == '') {
            N.getRSAApi('/getRsaKeys')
            .then(res => {
                let resObj = JSON.parse(res.data);
                let resJson = JSON.parse(resObj.responseJson);
                if (resJson.privateKey && resJson.publicKey) {
                    let newKey = CryptoJS.enc.Utf8.parse('NexStepPrivacy@#');
                    // Decrypt
                    var privateKeyBytes = CryptoJS.AES.decrypt(resJson.privateKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
                    S.privateKey = privateKeyBytes.toString(CryptoJS.enc.Utf8);

                    var publicKeyBytes = CryptoJS.AES.decrypt(resJson.publicKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
                    S.publicKey = publicKeyBytes.toString(CryptoJS.enc.Utf8);
                    fetchdatatableData();
                }
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }
    const openPreviewModalHandler = () => { setShowUserPopup(true) }
    const openAuditModalHandler = () => { setshowUserPopupAudit(true) }
    const showLoaderPopup = () => { setShowLoader(true) }
    const closeLoader = () => { setShowLoader(false) }
    const closePopup = () => { setShowUserPopup(false) }
    const closeAuditPopup = () => { setshowUserPopupAudit(false) }
    const closeEditPopup = () => { setShowUserPopupEdit(false) }
    const handleEdit = (oldData) => { setOldRecord({ oldData }); setShowUserPopupEdit(true); }
    return (
        <div id="content-wrapper" className="d-flex flex-column">
            {<Sidebar />}
            {<Topbar />}
            <div id="wrapper">
                <div id="content">
                    {/* <!-- Begin Page Content --> */}
                    <Container fluid>
                        <Row>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 mb-2 mt-2">
                                <div className="card dash-data-card">
                                    <div className="card-header pl-4 pr-4">
                                        <h5 className="headerTitle float-left mt-1">Manage Users</h5>
                                        <Button variant='light' type="button" className="btn btn-sm shadow-sm float-right ml-2" title="Audit Log" onClick={()=>{openAuditModalHandler();}}>
                                            <FaHistory className="fas fa-plus" /><b style={{verticalAlign: 'middle'}}>Audit Log</b>
                                        </Button>
                                        {(localStorage.getItem("isCreateUserRole")) ?
                                                <Button type="button" className="btn btn-sm btn-primary shadow-sm float-right" onClick={openPreviewModalHandler}>
                                                    <FaPlus className="fas fa-plus pr-1" /><b style={{ verticalAlign: 'middle' }}>Create User</b>
                                                </Button> 
                                        : null }
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row className="mb-3">
                            <Col lg='12'>
                                <div className="card dash-data-card">
                                    <div className="card-body pl-4 pr-4">
                                        {(localStorage.getItem("isEditUserRole")) ?
                                            <table id="viewUser" className="display">
                                                <thead>
                                                    <tr>
                                                        <th>User Name</th>
                                                        <th>User Code</th>
                                                        <th>User Full Name</th>
                                                        <th>User Status</th>
                                                        <th></th> 
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data?.Payload?.userList?.map((result) => {
                                                        return (
                                                            <tr>
                                                                <td>{result.UserName}</td>
                                                                <td>{result.UserCode}</td>
                                                                <td>{result.UserFullName}</td>
                                                                <td>{result.UserStatus === 'Y' ? "Active" : "Inactive"}</td>
                                                                <td>
                                                                    <Button variant='light' className='btn-sm' onClick={() => handleEdit(result)}><FaPencilAlt /></Button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table> :
                                            <table id="viewUser" className="display">
                                                <thead>
                                                    <tr>
                                                        <th>User Name</th>
                                                        <th>User Code</th>
                                                        <th>User Full Name</th>
                                                        <th>User Status</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data?.Payload?.userList?.map((result) => {
                                                        return (
                                                            <tr>
                                                                <td>{result.UserName}</td>
                                                                <td>{result.UserCode}</td>
                                                                <td>{result.UserFullName}</td>
                                                                <td>{result.UserStatus === 'Y' ? "Active" : "Inactive"}</td>
                                                                <td></td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        }
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Loader showLoader={showLoader} />
                    <AddUser showUserPopup={showUserPopup} closeModal={closePopup} />
                    {showUserPopupAudit ? <>
                       <ManageUserAudit showUserPopupAudit={showUserPopupAudit} closeModal={closeAuditPopup} />
                    </> : null 
                    }
                    {showUserPopupEdit ? <>
                        <EditUser oldRecord={oldRecord} showUserPopupEdit={showUserPopupEdit} closeEditModal={closeEditPopup} />
                    </> : null
                    }
                    {/* <!-- /.container-fluid --> */}
                </div>
            </div>
        </div>
    )
}
export default ManageUser;